import { useMutation, useQueryClient } from '@tanstack/react-query'
import React from 'react'
import toast from 'react-hot-toast';
import { uploadCompletionAddDocs as uploadCompletionAddDocsAPI } from 'services/apiReport';

const useUploadCompletionAddDocs = () => {
  const queryClient = useQueryClient()

  const {isPending:isLoading,isSuccess:isDone,mutateAsync:uploadCompletionAddDocs} = useMutation({
    mutationFn: uploadCompletionAddDocsAPI,
    onSuccess:(data)=>{
        queryClient.setQueriesData(["completionAddDocs"],data)
        toast.success("Upload Success")
    },
    onError:(error)=>{
        toast.error(error?.data?.message || "An error occurred while calling completion api")
        console.error("Error occurred:",error)
    }
  })

return{isLoading,isDone,uploadCompletionAddDocs}
}

export default useUploadCompletionAddDocs